export enum SelectAllActionTypes {

  SET_SELECT_ALL_LOADER = "SET_SELECT_ALL_LOADER",

  FETCH_SELECT_ALL_LOCATIONS_SAGA = "FETCH_SELECT_ALL_LOCATIONS_SAGA",

  FETCH_SELECT_ALL_LOCATIONS = "FETCH_LOCATIONS",
  FETCH_SELECT_ALL_LOCATIONS_SUCCESS = "FETCH_SELECT_ALL_LOCATIONS_SUCCESS",
  FETCH_SELECT_ALL_LOCATIONS_ERROR = "FETCH_LOCATIONS_ERROR",

  FETCH_SELECT_ALL_NEW_PRODUCT_SAGA = "FETCH_SELECT_ALL_NEW_PRODUCT_SAGA",
  FETCH_SELECT_ALL_NEW_PRODUCT_SUCCESS = "FETCH_SELECT_ALL_NEW_PRODUCT_SUCCESS",

  FETCH_SELECT_ALL_OLD_PRODUCT_SAGA = "FETCH_SELECT_ALL_OLD_PRODUCT_SAGA",
  FETCH_SELECT_ALL_OLD_PRODUCT_SUCCESS = "FETCH_SELECT_ALL_OLD_PRODUCT_SUCCESS",


  SET_SELECT_ALL_NEW_PRODUCT = "SET_SELECT_ALL_NEW_PRODUCT",
  SET_SELECT_ALL_NEW_PRODUCT_SAGA = "SET_SELECT_ALL_NEW_PRODUCT_SAGA",

  SET_OLD_PRODUCT = "SET_OLD_PRODUCT",

  SET_SELECT_ALL_SELECTED_LOCATIONS_SAGA = "SET_SELECT_ALL_SELECTED_LOCATIONS_SAGA",

  SET_SELECT_ALL_SELECTED_LOCATIONS = "SET_SELECT_ALL_SELECTED_LOCATIONS",

  SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SAGA = "SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SAGA",

  SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SUCCESS = "SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SUCCESS",

  CLEAR_SELECT_ALL_PAGE = "CLEAR_SELECT_ALL_PAGE"
}